import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, Events } from 'ionic-angular';
import { HttpClient } from '../../../../services/HttpClient';
import { CustomToast } from '../../../../util/CustomToast';

import { ImageSelector } from '../../../../util/imageSelector/imageSelector';

@Component({
  selector: 'page-add-research-line',
  templateUrl: 'addResearchLine.html',
  providers : [HttpClient, CustomToast]
})
export class AddResearchLinePage {

  modalCtrl : ModalController;
	
  httpClient : HttpClient;
  baseUrl;

  researchline = {
    name_es : '',
    name_en : '',
    description_es : '',
    description_en : '',
    image : '',
  };

  image = {
    id : -1,
    filename : 'addimage.png'
  };

  customToast : CustomToast;
  events : Events;


	constructor(public navCtrl: NavController, public navParams: NavParams, httpClient : HttpClient,customToast : CustomToast,modalCtrl : ModalController, events : Events) {
		this.modalCtrl = modalCtrl;
    this.httpClient = httpClient;
    this.baseUrl = this.httpClient.getBaseUrl();

    this.customToast = customToast;
    this.events = events;
	}

  httpPostResearchLine(){
    console.log("asd");
    
    this.httpClient.post('/researchlines',this.researchline,(error,data)=>{
      if(!error){
        this.customToast.showMessage('Departamento creado correctamente',2000);
        this.navCtrl.pop();
        this.events.publish('addResearchLine:done');
      }
    });
  }

  onClickSave(){
    this.httpPostResearchLine();
  }

  onClickImage(){
    let modal = this.modalCtrl.create(ImageSelector);
    modal.present();
    modal.onDidDismiss(image => {
      if(image){
        this.image = image;
        this.researchline.image = image.filename;
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/dashboard/researchLines/addResearchLine/addResearchLine.ts